import apiClient from './client';

export const getAchievements = async () => {
  const res = await apiClient.get('/api/achievements');
  return res.data;
};

// New-substrate (drug-card unlock) surfaces — populated under the Septyx
// "achievement = drug-card unlock" model. See CP-5f-v3-achievements-as-drug-unlocks-subspec.md.
export const getDrugCardUnlocks = async () => {
  const res = await apiClient.get('/api/achievements/unlocks');
  return res.data?.unlocks || [];
};

export const getDrugCardAchievementProgress = async () => {
  const res = await apiClient.get('/api/achievements/progress');
  return res.data?.progress || [];
};
